import React from 'react';
export const FooterSection = () => {
  return <footer className="bg-gray-800 text-white py-4 text-center" data-id="element-11">
      <div className="max-w-4xl mx-auto px-4" data-id="element-12">
        <p className="text-sm" data-id="element-13">© 2025 Relievana™. All Rights Reserved.</p>
        <p className="mt-2 text-sm" data-id="element-14">
          Privacy Policy | Terms of Service | Contact Us
        </p>
      </div>
    </footer>;
};